<template>
    <div class="container">
      <!-- 标题部分 -->
      <div class="header">
        <h3>OM</h3>
        <h1 class="title">DIALEKTISK BEHANDLING</h1>
        <p class="description">
          Akupunkturbehandling är bara en del av traditionell kinesisk medicinbehandling. 
          Det måste styras av traditionell kinesisk medicinteori för att få bättre effekt.
        </p>
      </div>
  
      <!-- 两列布局 -->
      <el-row :gutter="20" justify="center">
        <el-col v-for="(item, index) in treatments" :key="index" :span="12">
          <el-card shadow="hover" class="card">
            <img :src="item.image" class="card-image" alt="Treatment Image" />
            <h3 class="card-title">{{ item.title }}</h3>
            <p class="card-text">{{ item.description }}</p>
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 额外列表文本 -->
      <div class="extra-info">
        <p v-for="(text, index) in extraTexts" :key="index" class="extra-text">{{ text }}</p>
      </div>
  
      <!-- 预约按钮 -->
      <div class="button-container">
        <el-button type="success" plain class="book-button" @click="toLink">BOKA TID</el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "halpPage",
    data() {
      return {
        treatments: [
          {
            title: "SMÄRTA",
            description: "Huvudvärk/migrän, nacke och skuldra, frusen skuldra, ryggvärk, artrit...",
            image: require("@/assets/help/help1.jpg"),
          },
          {
            title: "RESPIRATORISKA SJUKDOMAR",
            description: "Astma, bronkit och bihåleinflammation.",
            image: require("@/assets/help/help2.jpg"),
          },
          {
            title: "ALLERGI",
            description: "Näs- och ögonallergi (hösnuva), eksem, födoämnesallergier.",
            image: require("@/assets/help/help3.jpg"),
          },
          {
            title: "PROBLEM MED CIRKULATION",
            description: "Angina pectoris, högt/lågt blodtryck, hjärtklappning...",
            image: require("@/assets/help/help4.jpg"),
          },
          {
            title: "MATSÄLTNING",
            description: "Mage-och tarmsjukdomar, diarre, förstoppning.",
            image: require("@/assets/help/help5.jpg"),
          },
          {
            title: "REPRODUKTIVA SYSTEMET SJUKDOMAR",
            description: "Infertilitet, nedsatt spermiekvalitet, impotens...",
            image: require("@/assets/help/help6.jpg"),
          },
        ],
        extraTexts: [
          "Depression & Stress, Ångest, Trötthet och Sömnlöshet",
          "Klimakteriesjukdomar",
          "Förlamning, Ansiktsförlamning, Multipel skleros",
          "Biverkningar av cancer",
          "Tinnitus, Ögonsjukdomar",
          "Rökavvänjning och Viktminsknin",
        ],
      };
    },
    methods: {
      // 新增方法，用于打开指定链接
      toLink() {
        window.open('https://yghealthab.simplybook.it/v2/', '_blank');
      }
    }
  };
  </script>
  
  <style scoped>
  /* 页面容器 */
  .container {
    min-width: 1200px; 
    width: 1200px; 
  }
  
  /* 标题部分 */
  .header {
    text-align: left;
    margin-bottom: 30px;
    border-left: 5px solid #2e7d32;
    padding-left: 15px;
  }
  .title {
    color: #1c2a4b;
    font-weight: bold;
  }
  .description {
    color: #555;
    font-size: 16px;
  }
  
  /* 卡片样式 */
  .card {
    text-align: center;
    padding: 15px;
  }
  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .card-title {
    font-size: 18px;
    font-weight: bold;
    color: #1c2a4b;
    margin-top: 10px;
  }
  .card-text {
    font-size: 14px;
    color: #555;
  }
  
  /* 额外文本样式 */
  .extra-info {
    margin-top: 30px;
    text-align: left;
  }
  .extra-text {
    font-size: 16px;
    font-weight: bold;
    color: #1c2a4b;
    margin-bottom: 5px;
    text-align: center;
  }
  
  /* 按钮 */
  .button-container {
    text-align: center;
    margin-top: 20px;
  }
  .book-button {
    border: 2px solid #4caf50;
    color: #4caf50;
    font-weight: bold;
  }
@media (max-width: 768px) {
    .container {
        width: 95%;
        padding: 0 10px;
    }
    
    .header {
        margin-bottom: 20px;
        padding-left: 10px;
    }
    
    .el-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    
    .el-col {
        width: 100% !important;
        margin-bottom: 15px;
    }
    
    .card {
        padding: 10px;
    }
    
    .card-image {
        height: 120px;
    }
    
    .extra-info {
        margin-top: 20px;
    }
    
    .extra-text {
        font-size: 14px;
        text-align: left;
        padding: 0 10px;
    }
    
    .book-button {
        width: 100%;
        margin-bottom: 20px;
    }
}
  </style>
  
